export default {
    createLayout(customerId, payload) {
        return axios.post(`/banner/${customerId}/group/store_ajax`, payload)
    },
    saveAsTemplate(data) {
        return axios.post('/banner/save_as_template', data);
    },
    updateLayout(customerId, layoutId, data) {
        return axios.post(`/banner/${customerId}/group/${layoutId}/update_ajax`, data);
    },
    copyAndTranslate(url, data) {
        return axios.post(url, data);
    },
    async copy(gridLayoutId) {
      const requestData = await axios.get(`/banner/0/group/${gridLayoutId}/copy?api_request=true`);
      return requestData.data;
    },
    getTranslationForFields(layoutPartPath, instance, data) {
        const instanceId = instance.data.instance_id ?? instance.id;
        const url = `${layoutPartPath}template/${instanceId}/${instance.data.template_id}/get_translation_for_fields`;

        return axios.post(url, data);
    },
    translate(layoutPartPath, instance, data) {
        const instanceId = instance.data.instance_id ?? instance.id;
        const url = `${layoutPartPath}template/${instanceId}/${instance.data.template_id}/translate_template`;

        return axios.post(url, data);
    },
    updateTemplate(data) {
        return axios.post('/banner/update_existing_template', data);
    },
    updateTemplateThumbnail(data) {
        return axios.post('/banner/update_template_thumbnail', data);
    },
    generateLayoutThumbnail(layoutId) {
        return axios.post('/banner/generate-layout-thumbnail', { layout_id: layoutId });
    },

    getPreviews(customerId, layoutId) {
      return axios.get(`/banner/${customerId}/group/${layoutId}/preview`);
    },
    getLayoutsCustomer(customerId, data = {}) {
      return axios.get(`/banner/${customerId}/group/get-layouts-customer`, data);
    },
    getNextLayoutName(customerId) {
        return axios.get(`/banner/${customerId}/group/next-layout-name`);
    },
    getLayoutTemplates(layoutId, params = {}) {
        return axios.get(`/banner/groups/${layoutId}/templates`, { params: params });
    },
    downloadLayoutPdfFromProof(proof, data) {
        return axios.get(`/banner/${proof}/download_layout_pdf`, data);
    },
    downloadProofZip(proofId, instanceIds = null) {
        const body = { proof_id: proofId };

        if (Array.isArray(instanceIds) && instanceIds.length) {
            body.instance_ids = instanceIds.map(String);
        }

        return axios.post('/banner/download-proof-zip', body, { responseType: 'blob' });
    },
    downloadProofZipBulk(proofs) {
        const normalized = (Array.isArray(proofs) ? proofs : []).map((entry) => {
            if (entry && typeof entry === 'object') {
                return {
                    proof_id: entry.proof_id,
                    instance_ids: Array.isArray(entry.instance_ids) && entry.instance_ids.length
                        ? entry.instance_ids.map(String)
                        : null,
                };
            }

            return { proof_id: entry, instance_ids: null };
        });

        return axios.post('/banner/download-proof-zip-bulk', { proofs: normalized }, { responseType: 'blob' });
    },
    toggleFavorite (layoutId) {
        return axios.post(`/banner/groups/${layoutId}/toggle-favorite`)
    },

    getLayouts(data = {}) {
      return axios.get(`/banner/groups/layouts`, data);
    },
    createLayoutAndTemplateFromImage(customerId, payload) {
        return axios.post(`/banner/${customerId}/group/create_layout_and_template_from_image`, payload);
    },
    updateLayoutSettings(customerId, layoutId, payload) {
        return axios.patch(`/banner/${customerId}/group/${layoutId}/settings`, payload);
    },
    saveRecording(layoutId, payload) {
      return axios.post(`/recording/${layoutId}/save/`, payload);
    },
    getRecordings(layoutId, page = 1) {
      return axios.get(`/recording/${layoutId}?page=${page}`);
    },
    deleteRecording(recordingId) {
      return axios.delete(`/recording/${recordingId}`);
    },
    deleteLayout(layoutId, customerId) {
      return axios.delete(`/banner/${customerId}/group/${layoutId}`);
    }
}

